import { Box } from '@frontend/legacy-components';

import { RELAY_URL } from 'constants/all';

/**
 * Hosts the Relay SPA (v2/apps/rfq-app) in an iframe below quoting's header.
 * Quoting loads it from its own URL and never imports its code.
 */
export const RelayPage = () => (
  <Box
    as="iframe"
    src={RELAY_URL}
    title="Vendor RFQs"
    display="block"
    width="100%"
    height="100%"
    border="none"
  />
);
